import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=f955f052&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"
import style0 from "./Terms.vue?vue&type=style&index=0&id=f955f052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f955f052",
  null
  
)

export default component.exports